import { getHeight } from "../../../style/Helper";

export const mainContainerLayout1 = [
  {
    col: "col-md-4",
    title: "Metric 1",
    height: getHeight() * 0.3,
  },
  {
    col: "col-md-4",
    title: "Metric 2",
    height: getHeight() * 0.3,
  },
  {
    col: "col-md-4",
    title: "Metric 3",
    height: getHeight() * 0.3,
  },
];
export const mainContainerLayout2 = [
  {
    col: "col-md-12",
    title: "Diary",
    height: getHeight() * 0.35,
    type: "Diary",
    redirectTo: "/app/diary",
    url: "",
    pagination: false,
    sort: false,
  },
];
export const mainContainerLayout3 = [
  {
    col: "col-md-12",
    title: "Workflow",
    height: getHeight() * 0.35,
    type: "WorkFlow",
    redirectTo: "/app/policy/workFlow",
    url: "",
    pagination: false,
    sort: false,
  },
];

export const leftLayout = [
  {
    col: "col-md-12",
    title: "Reminders",
    height: getHeight() + 15,
    type: "Calendar",
  },
];
